/**
 * E-Prescription Feature Module
 *
 * Minimal feature configuration for API-only features.
 * No Redux slice needed since all state is managed by RTK Query.
 */

import type { FeatureModule } from '@store/features/types';

/**
 * E-Prescriptions feature module definition
 */
export const eprescriptionsFeature: FeatureModule = {
  id: 'eprescriptions',
  name: 'E-Prescriptions',

  // No dependencies for this feature
  dependencies: [],

  // No reducers needed - API-only feature
  reducers: {},

  // No middleware needed
  middleware: [],

  // No persistence needed
  persistence: {
    enabled: false,
  },

  // No sync needed
  sync: {
    enabled: false,
  },

  setup: () => {
    console.debug('E-Prescriptions feature initialized');
  },

  cleanup: () => {
    console.debug('E-Prescriptions feature cleaned up');
  },
};
